import { useCallback, useEffect, useRef, useState } from 'preact/hooks'
import { sendingDomainsApi } from '@/api/sendingDomains'
import type { SendingDomainWarmupSummaryDto } from '@/types/sendingDomains'

/** Today's sends and held emails for every domain of the company: one call for the whole list. */
export function useWarmupSummary(clientCompanyId: string) {
  const [summary, setSummary] = useState<SendingDomainWarmupSummaryDto | null>(null)
  const [error, setError] = useState<string | null>(null)
  // Only the latest load may write, so a reload that overtakes an earlier one is not undone by it.
  const requestIdRef = useRef(0)

  const reload = useCallback(async () => {
    const requestId = ++requestIdRef.current
    const res = await sendingDomainsApi.warmupSummary(clientCompanyId)
    if (requestIdRef.current !== requestId) return
    setError(res.error ?? null)
    if (res.data) setSummary(res.data)
  }, [clientCompanyId])

  useEffect(() => {
    void reload()
    return () => { requestIdRef.current++ }
  }, [reload])

  return { summary, error, reload }
}
